// src/routes/NoMenuLayout.jsx
import { Outlet, Link as RouterLink } from "react-router-dom";
import { Box, Container, Link } from "@mui/material";

export default function NoMenuLayout() {
  return (
    <>
      <Box
        sx={{
          borderBottom: "1px solid #e0e0e0",
          backgroundColor: "#fff",
        }}
      >
        <Container maxWidth="xl">
          <Box sx={{ py: 1 }}>
            <Link
              component={RouterLink}
              to="/"
              underline="none"
              sx={{ fontSize: 14 }}
            >
              ← На головну
            </Link>
          </Box>
        </Container>
      </Box>

      <Outlet />
    </>
  );
}